import { isEmptyValue } from "./tool";

export function getDateYYYYMMDDHHMISS() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    if (hour < 10) {
        hour = '0' + hour;
    }
    if (minute < 10) {
        minute = '0' + minute;
    }
    if (second < 10) {
        second = '0' + second;
    }
    return year + "" + month + "" + day + "" + hour + "" + minute + "" + second;
}

export function getDateStr() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    if (hour < 10) {
        hour = '0' + hour;
    }
    if (minute < 10) {
        minute = '0' + minute;
    }
    if (second < 10) {
        second = '0' + second;
    }
    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}

export function getDateYYYYMMDD() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return year + "-" + month + "-" + day;
}

export function add0(m) {
    return m < 10 ? '0' + m : m
}

export function dateFormat(_time) {
    let _date = new Date(_time);
    let y = _date.getFullYear();
    let m = _date.getMonth() + 1;
    let d = _date.getDate();
    return y + '-' + add0(m) + '-' + add0(d);
}

export function dateFormatSubSec(_time) {
    if (!_time) {
        return ''
    }
    let _date = new Date(_time);
    _date.setSeconds(_date.getSeconds() - 1);
    return dateFormat(_date);
}

export function timeFormat(_time) {
    let _date = new Date(_time);
    let h = _date.getHours();
    let mm = _date.getMinutes();
    let s = _date.getSeconds();
    return add0(h) + ':' + add0(mm) + ':' + add0(s);
}
export function timeMinFormat(_time) {
    let _date = new Date(_time);
    let h = _date.getHours();
    let mm = _date.getMinutes();
    return add0(h) + ':' + add0(mm);
}

export function dateSubOneDay(_startTime, _endTime, feeFlag) {
    if (!_endTime || _endTime == '-') {
        return _endTime
    }
    let dateTime = new Date(_endTime);
    let startTime = new Date(_startTime);
    //如果开始时间是31日 结束时间是30日 不做处理
    let _startTimeLastDay = startTime.getDate();
    let _endTimeLastDay = dateTime.getDate();
    if (_startTimeLastDay == 31 && _endTimeLastDay == 30) {
        return dateFormat(dateTime);
    }

    //2月份特殊处理
    let _endTimeMonth = dateTime.getMonth();
    if (_endTimeMonth == 1 && _endTimeLastDay > 26 && _startTimeLastDay > 26) {
        return dateFormat(dateTime);
    }

    if (feeFlag != "2006012") {
        dateTime = dateTime.setDate(dateTime.getDate() - 1);
    }
    dateTime = dateFormat(dateTime)
    return dateTime;
}

export function dateSub(dateTime, feeFlag) {
    if (!dateTime || dateTime == '-') {
        return dateTime
    }
    console.log("feeFlag:" + feeFlag);
    dateTime = new Date(dateTime);
    if (feeFlag != "2006012") {
        dateTime = dateTime.setDate(dateTime.getDate() - 1);
    }
    dateTime = dateFormat(dateTime)
    return dateTime;
}
export function dateAdd(dateTime) {
    if (!dateTime || dateTime == '-') {
        return dateTime
    }
    dateTime = new Date(dateTime);
    dateTime = dateTime.setDate(dateTime.getDate() + 1);
    dateTime = dateFormat(dateTime)
    return dateTime;
}

export function addOneDay(date) {
    // 将给定的日期转换为Date对象
    let currentDate = new Date(date);
    // 获取当前日期的时间戳
    let timestamp = currentDate.getTime();
    // 将时间戳加上一天的毫秒数（24小时 * 60分钟 * 60秒 * 1000毫秒）
    timestamp += 24 * 60 * 60 * 1000;
    // 根据新的时间戳创建一个新的Date对象
    const newDate = new Date(timestamp);
    // 返回新的日期对象
    return newDate;
}

export function daysInMonth(year, month) {
    if (month == 1) {
        if (year % 4 == 0 && year % 100 != 0)
            return 29;
        else
            return 28;
    } else if ((month <= 6 && month % 2 == 0) || (month = 6 && month % 2 == 1))
        return 31;
    else
        return 30;
}
export function addMonth(_date, _month) {
    let y = _date.getFullYear();
    let m = _date.getMonth();
    let nextY = y;
    let nextM = m;
    //如果当前月+要加上的月>11 这里之所以用11是因为 js的月份从0开始
    if ((m + _month) > 11) {
        nextY = y + 1;
        nextM = parseInt(m + _month) - 12;
    } else {
        nextM = m + _month
    }
    let daysInNextMonth = daysInMonth(nextY, nextM);
    let day = _date.getDate();
    if (day > daysInNextMonth) {
        day = daysInNextMonth;
    }
    let _newDate = new Date(nextY, nextM, day)
    return _newDate.getFullYear() + '-' + (_newDate.getMonth() + 1) + '-' + _newDate.getDate() + " " + _date.getHours() + ":" + _date.getMinutes() + ":" + _date.getSeconds();
}

export function formatDateTime(date) {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    const hours = String(d.getHours()).padStart(2, '0')
    const minutes = String(d.getMinutes()).padStart(2, '0')
    const seconds = String(d.getSeconds()).padStart(2, '0')
    return `${year}-${month}-${day}`;
    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}


/**
 * 日期格式化函数
 * @param {string|Date} date - 日期，可以是字符串或Date对象
 * @param {string} format - 格式化模板
 * @returns {string} 格式化后的日期字符串
 * 
 * 格式化符号说明:
 * yyyy: 4位年份
 * yy: 2位年份
 * MM: 2位月份(01-12)
 * M: 月份(1-12)
 * dd: 2位日期(01-31)
 * d: 日期(1-31)
 * HH: 2位小时(00-23)
 * H: 小时(0-23)
 * hh: 2位小时(01-12)
 * h: 小时(1-12)
 * mm: 2位分钟(00-59)
 * m: 分钟(0-59)
 * ss: 2位秒数(00-59)
 * s: 秒数(0-59)
 * w: 星期(0-6, 0表示周日)
 * W: 星期(日-六)
 * a: 上午/下午
 */
export function formatDate(date, format = 'yyyy-MM-dd HH:mm:ss') {

    console.log('formatDate date&format', date, format);

    if (isEmptyValue(date)) {
        return ''
    }

    // 1. 处理传入的日期参数
    let dateObj;
    if (typeof date === 'string') {
        if (date == '') {
            return ''
        }
        // 尝试将字符串转换为Date对象
        dateObj = new Date(date);
        // 检查转换是否有效
        if (isNaN(dateObj.getTime())) {
            throw new Error('无效的日期字符串');
        }
    } else if (date instanceof Date) {
        dateObj = date;
        // 检查Date对象是否有效
        if (isNaN(dateObj.getTime())) {
            throw new Error('无效的Date对象');
        }
    } else {
        throw new Error('第一个参数必须是字符串或Date对象');
    }

    // 2. 验证格式化字符串参数
    if (typeof format !== 'string') {
        throw new Error('第二个参数必须是字符串');
    }

    // 3. 获取日期的各个部分
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1; // 月份从0开始，需要+1
    const day = dateObj.getDate();
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const seconds = dateObj.getSeconds();
    const weekday = dateObj.getDay(); // 0-6, 0表示周日

    // 4. 准备替换数据
    const replacements = {
        'yyyy': year.toString(),
        'yy': year.toString().slice(-2),
        'MM': month.toString().padStart(2, '0'),
        'M': month.toString(),
        'dd': day.toString().padStart(2, '0'),
        'd': day.toString(),
        'HH': hours.toString().padStart(2, '0'),
        'H': hours.toString(),
        'hh': (hours % 12 || 12).toString().padStart(2, '0'), // 12小时制，0点显示为12
        'h': (hours % 12 || 12).toString(), // 12小时制
        'mm': minutes.toString().padStart(2, '0'),
        'm': minutes.toString(),
        'ss': seconds.toString().padStart(2, '0'),
        's': seconds.toString(),
        'w': weekday.toString(),
        'W': ['日', '一', '二', '三', '四', '五', '六'][weekday],
        'a': hours < 12 ? '上午' : '下午'
    };

    // 5. 执行替换
    let result = format;

    // 按照键的长度从长到短排序，避免替换冲突（如先替换'y'会影响到'yyyy'）
    const keys = Object.keys(replacements).sort((a, b) => b.length - a.length);

    for (const key of keys) {
        result = result.replace(new RegExp(key, 'g'), replacements[key]);
    }

    return result;
}
